<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from 'echarts';
import 'echarts-liquidfill'
import chartResize from "./mixins/chart-resize";

import _lodash_findIndex from 'lodash/findIndex';
import _lodash_sortBy from 'lodash/sortBy';
import _lodash_ceil from 'lodash/ceil';
import _lodash_floor from 'lodash/floor';
import _lodash_round from 'lodash/round';

export default {
  name: "BallCustom",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    radius:{
        type:String,
        default:()=>'55%'
    },
    stitle:{
      type:String,
      default:()=>''
    },
    source: {
      type: Array,
      default: () => [
        // { name: '安防预警', count: 33621 },
        // { name: '消防预警', count: 9574 },
        // { name: '防雷预警', count: 12541 }
      ],
    },
    center:{
        type:Array,
        default:()=>[
            ['18%', '50%'],
            ['50%', '50%'],
            ['82%', '50%']
        ]
    },
    colorDic: {
      type: Object,
      default: () => {
        return {
           //fillColor: ['#ff9597', '#ff4342', '#f67209', '#837e7b', '#e6f005', '#158f85', '#b33355','#2650b7'],
           // 'rgba(164,24,77,0.9)', 'rgba(154,53,18,0.9)', 'rgba(156,88,14,0.9)', 'rgba(49,68,168,0.9)'],
          borderColor: ['#d92b75', '#ca5637', '#cb7729', '#425ad8'],
          itemColor:[
            {start:'#ff4342',end:'#ff9597'},//线性渐变色
            {start:'#ffd044',end:'#ffcc38'},
            {start:'#012643',end:'#0fc1fd'},
            {start:'#263674',end:'#0ec0fc'},
            {start:'#053c5b',end:'#11c1fd'}
          ],
          lineColor:'#34cbf6',
          backgroundColor:['transparent','transparent','transparent'],
          outBackgroundColor:['#003c60','#313052','#2a4742'],
          fillColor:[ '#065cff','#ff4f51','#f5cb1d']

        }
      },
    },
      grid:{
        type:Object,
        default:()=> {
            return {
                top: '5%',
                left: '0%',
                right: '0%',
                bottom: '5%',
                containLabel: true,
            }
        }
    },
    nameField:{
        type:String,
        default:"name"
    },
    valueField:{
        type:String,
        default:"count"
    },
    defaultBackgroundColor:{
        type:String,
        default:"transparent"
    },
    defaultFillColor:{
        type:String,
        default:"transparent"
    }
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    source: {
      deep: true,
      handler(val) {
        this.chart.clear();
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions() {
      const data = this.initData(this.source);
      let option={}; 
      option.tooltip= {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
        textStyle:{
            fontSize:'75%'
        }
      };
      option.series=[];
        for (let i = 0; i < data.valueArray.length; i++) {
            console.log(data.data[i])
            option.series.push({
                type: 'liquidFill',
                radius: this.radius,// '35%',
                color: [this.colorDic.fillColor[i]],//内部颜色
                center:this.center[i],  //['25%', '50%'],
                data: [data.percent[i], data.percent[i], data.percent[i], data.percent[i], data.percent[i]],
                backgroundStyle: {
                    borderWidth: 2,
                    borderColor: this.colorDic.fillColor[i],// '#1789fb',
                    color: this.colorDic.backgroundColor[i]
                },
                outline: {
                    borderDistance: 0,// 间隔宽度
                    itemStyle: {
                        borderWidth: 5,
                        borderColor: this.colorDic.outBackgroundColor[i],// '#1789fb',
                        borderType: 'solid' // 'dashed', 实线虚线
                    }
                },
                label: {
                   normal: {
                       formatter: `{a|${data.data[i].value}}`+'\n\n'+data.data[i].name,
                       textStyle: {
                           fontSize: 12,
                           insideColor: 'yellow',
                           color: '#fff',
                       },
                       rich: {
                        a: {
                          fontSize: 24,
                          fontWeight: 'normal',
                          verticalAlign: 'bottom'
                        },
                       }
                   }
               }
            })
        }
        option.grid=this.grid;
        this.chart.setOption(option)
    },
     initData(source) {
        var axisArray = []  //坐标轴内容
        var valueArray= []; //值数组
        var data = []       //数据 name,value 键值对
        var total=0;        //总数
        var percent=[];     //百分比
        var percent100=[];   //100 
        var temp=[];
        var maxValueArray=[];
        var maxValue=0;
        
        temp =source;   //不排序
        var tempResort = _lodash_sortBy(source, (info) => -info[this.valueField]);//倒序
        maxValue=tempResort[0] ? tempResort[0][this.valueField]:0 ;
        temp.forEach((info, index) => {
            axisArray.push(info[this.nameField]);
            valueArray.push(info[this.valueField]);
            data.push({
                name: info[this.nameField],
                value: info[this.valueField],
            })
            total+=info[this.valueField];
            maxValueArray.push(_lodash_ceil(maxValue*1.2));
        })
        
        for (let i = 0; i < data.length; i++) {
          if(total>0){
            // console.log(data[i].value/total, "before");
            percent[i]=_lodash_round(data[i].value/total,4);
            // console.log(percent[i], "after");
          }
          else{
            percent[i]=0;
          }
        }
        // console.log(percent);
        return { axisArray,valueArray,data,total,percent,percent100,maxValueArray}
    },
  },
};
</script>
